import { HomeProps } from './Home.props';

import { $session } from 'state/stores';
import HomeView from './Home.view';

const HomeContainer = (props: HomeProps) => {
  const isAuthenticated = $session.selectors.useIsAuth();
  const currentUserId = $session.actions.getUserId();

  return (
    <HomeView isAuthenticated={isAuthenticated} currentUserId={currentUserId} />
  );
};

export default HomeContainer;
